<template>
  <Toast/>
  <div class="row">
    <div v-if="estParent=='true'">
      <h2 class="titre">Consulter/Modifier un intervenant (parent intervenant) et son profil (intervenant)</h2>
    </div>
    <div v-else>
      <h2 class="titre">Consulter/Modifier un profil (intervenant)</h2>
    </div>
    <InformationParentIntervenant :intervenant="intervenant" :modifierParent="estParent"
                                  ref="informationParentIntervenant"/>
    <InformationIntervenant :intervenant="intervenant" ref="informationIntervenant"/>
    <InformationJustification ref="informationJustification"/>
    <div class="row">
      <div class="col">
        <Button label="Sauvegarder" v-on:click="sauvegarder"/>
      </div>
      <div class="col">
        <Button label="Audit" v-on:click="audit"/>
      </div>
      <div v-if="this.intervenant.compteParent" class="col">
        <Button label="Ajouter profil" v-on:click="ajouterProfil"/>
      </div>
      <div class="col">
        <Button label="Fermer" v-on:click="fermer"/>
      </div>
    </div>
  </div>
</template>
<script>

import {mapGetters} from "vuex";
import axios from "axios";
import InformationIntervenant from "@/components/pilotage/intervenant/Consulter/InformationIntervenant.vue";
import InformationParentIntervenant from "@/components/pilotage/intervenant/Consulter/InformationParentIntervenant.vue";
import InformationJustification from "@/components/pilotage/intervenant/Consulter/InformationJustification.vue";

export default {
  name: "IntervenantConsulterModifier",
  components: {
    InformationParentIntervenant,
    InformationIntervenant,
    InformationJustification,
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      intervenant: "pilotage/intervenant",
    })
  },
  data() {
    return {
      estParent: null,
    };
  },
  beforeMount() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consulter/Modifier Intervenant");
    this.getIntervenant()
  },
  methods: {
    getIntervenant() {
      this.$store.dispatch('pilotage/consulterIntervenantAction', {cle: this.$route.params.cle})
          .then((res) => {
            this.$store.commit('pilotage/UPDATE_INTERVENANT', res.data);
            this.$refs.informationIntervenant.setIntervenant(res.data);
            this.$refs.informationParentIntervenant.setIntervenantParent(res.data.intervenantCommunVO);
            this.estParent = res.data.compteParent.toString();
          });
    },
    sauvegarder() {
      let intervenantLocal = this.$refs.informationIntervenant.getIntervenant();
      intervenantLocal.intervenantCommunVO = this.$refs.informationParentIntervenant.getIntervenantParent();
      intervenantLocal.justification = this.$refs.informationJustification.getJustification();
      this.$store.dispatch('pilotage/modifierIntervenantAction', intervenantLocal)
          .then((res) => {
            if (res.status == 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Sauvegarder',
                detail: 'La modification a été enregistré.',
                life: 6000
              });
              intervenantLocal.justification = this.$refs.informationJustification.clearJustification();
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Sauvegarder',
                detail: 'La modification n\'a été enregistré.',
                life: 6000
              });
            }
            this.setDateAfterSauvegarde(intervenantLocal);
          });
    },
    setDateAfterSauvegarde(intervenantLocal) {
      intervenantLocal.dateFinEmploi = this.$commun.formatDate(intervenantLocal.dateFinEmploi);
      intervenantLocal.dateDerniereEvenement = this.$commun.formatDateHeure(intervenantLocal.dateDerniereEvenement);
      intervenantLocal.intervenantCommunVO.dateDebutEmploi = this.$commun.formatDate(intervenantLocal.intervenantCommunVO.dateDebutEmploi);
    },
    ajouterProfil() {
      this.$router.push({
        name: 'ajouterIntervenantPilotage',
        params: {modifierParent: 'false', cle: this.$route.params.cle}
      });
    },
    audit() {
      this.$router.push({
        name: 'intervenantAuditModifications',
        params: {modifierParent: 'false', cle: this.$route.params.cle}
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  },
}

</script>